





























































































import { Component, Ref, Vue } from "vue-property-decorator";
import { FormValidator } from "@/utils/formValidator";
import { ApiRegister, ApiSmsCode } from "@/api/login/index";
import { Form } from "element-ui/types";

@Component({ name: "Register" })
export default class extends Vue {
  public registerForm = {
    phone: "",
    password: "",
    smsCode: "",
    // agreement: null,
  };
  i = 61;
  text = "获取验证码";
  disabled = false;
  // registerDisabled = true;
  agreementCheck = false;
  /**
   * 验证器
   */
  public FormValidator = FormValidator;
  /**
   * 密码框是否睁开眼
   */
  public hasOpenEye = false;
  /**
   * 登录按钮是否需要loding
   */
  public loading = false;
  /**
   * 表单的ref
   */
  @Ref() readonly registerFormRef!: Form;
  /**
   * 刷新验证组件的key
   */
  rules = {
    phone: [
      { required: true, message: "输入手机号", trigger: "blur" },
      {
        pattern: /^1(3\d|4\d|5\d|6[02567]|7[0-8]|8\d|9[0-3,5-9])\d{8}$/,
        message: "请输入正确的手机号",
        trigger: "change",
      },
    ],
    password: [
      { required: true, message: "输入密码", trigger: "blur" },
      {
        min: 6,
        max: 12,
        message: "请输入6-12位密码,包含字母、符号、数字",
        trigger: "change",
      },
    ],
    smsCode: [{ required: true, message: "输入验证码", trigger: "blur" }],
    // agreement: [{ required: true, message: "请勾选同意协议", trigger: "blur" }],
  };
  public loginValidateKey: string = Date.now().toString();
  public register() {
    if (!this.agreementCheck) {
      this.agreementCheck = false;
    }
    this.registerFormRef.validate(async (valide: boolean) => {
      if (valide) {
        // 登录获取数据
        await ApiRegister(this.registerForm);

        this.$message.success("注册成功");
        this.$router.push("/login");
        this.loading = false;
      }
    });
  }
  async sendsms() {
    let a = 0; // 用来限制只允许校验一次
    this.registerFormRef.validateField("phone", async (errorMsssage) => {
      if (errorMsssage === "") {
        a++;
        if (a === 1) {
          const fn = () => {
            if (this.i === 1) {
              clearInterval(timerID);
              this.text = "发送验证码";
              this.i = 61;
              this.disabled = false;
              return;
            }
            this.i--;
            this.text = "重发验证码" + "(" + this.i + "s)";
            this.disabled = true;
          };
          let timerID = null as any;
          // 表单验证通过，获取验证码
          await ApiSmsCode({ phone: this.registerForm.phone })
            .then((data) => {
              fn();
              this.$message.success("验证码已发送");
              timerID = setInterval(fn, 1000);
            })
            .catch((error) => {
              if (error.data.msg === "手机号码已存在") {
                this.disabled = true;
              }
            });
        }
      }
    });
  }

  // // 隐私政策
  // change(value: any) {
  //   console.log(this.registerDisabled);

  //   if (value) {
  //     this.registerDisabled = false;
  //   } else {
  //     this.registerDisabled = true;
  //   }
  // }
  // agreement() {
  //   // window.open("agreement.html");
  //   this.$router.push("/agreement.html");
  // }
}
